module.exports = __webpack_public_path__ + "img/voucher-used.ab662fd9.svg";